import { Box } from '@chakra-ui/react';
import { Bus } from 'core/infrastructure';
import * as React from 'react';
import { keyframes } from '@emotion/react';
import { useIsOnTop } from './modal/ModalHooks';
import { useEventOn } from 'core/infrastructure/Events';

// Animación step-fade-in
const gradientAnimation = keyframes`
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
`;

export const LoadingBar = () => {
	const [isLoading, setIsLoading] = React.useState(false);
	const ref = React.useRef<HTMLDivElement>(null);

	const isOnTop = useIsOnTop();

	const updateLoadingBar = React.useCallback(async () => {
		const inProgress = Bus.getPendingRequests().length !== 0;
		setIsLoading((isLoading) => (isLoading !== inProgress ? inProgress : isLoading));
	}, [setIsLoading]);

	useEventOn('request:started', updateLoadingBar);
	useEventOn('request:completed', updateLoadingBar);
	useEventOn('request:failed', updateLoadingBar);

	return <Box
		ref={ref}
		w='full'
		h={'1.5'}

		// El gradiente está duplicado con respecto a figma (se hace simétrico alrededor del 50%)
		// para que se pueda poner al 200% de tamaño y hacer la animación. De esta forma, cuando
		// no hay animación, se ve tal cual está diseñado en figma (sólo se ve la primera mitad)
		// y al animar, tiene un efecto razonable (como si fuera rebotando horizontalmente)
		bgGradient={`linear-gradient(90deg,
			var(--chakra-colors-yellow-500) 0%,
			var(--chakra-colors-pink-600) 25%,
			var(--chakra-colors-yellow-200) 50%,
			var(--chakra-colors-pink-600) 75%,
			var(--chakra-colors-yellow-500) 100%
		)`}
		bgSize='200%'

		overflowX='hidden'
		animation={isLoading && isOnTop ? `${gradientAnimation} 2s infinite linear 0.2s` : undefined}
		as='div'
	/>;
};
